import { createCollection, localStorageCollectionOptions } from '@tanstack/react-db';
import z from 'zod';

export const favoriteFiltersCollection = createCollection(
  localStorageCollectionOptions({
    id: 'favoriteFilters',
    storageKey: 'favorite-filters',
    getKey: (favoriteFilters) => favoriteFilters.type,
    schema: z.object({ type: z.string() }),
  }),
);

export const favoriteGranularitiesCollection = createCollection(
  localStorageCollectionOptions({
    id: 'favoriteGranularities',
    storageKey: 'favorite-granularities',
    getKey: (item) => item.type,
    schema: z.object({ type: z.string() }),
  }),
);

// Keyed by filter group id (falls back to name for groups without an id)
export const favoriteSavedFiltersCollection = createCollection(
  localStorageCollectionOptions({
    id: 'favoriteSavedFilters',
    storageKey: 'favorite-saved-filters',
    getKey: (item) => item.type,
    schema: z.object({ type: z.string() }),
  }),
);

// this should probably go on indexedDb instead of localStorage
export const filterUsageCollection = createCollection(
  localStorageCollectionOptions({
    id: 'filterUsage',
    storageKey: 'filter-usage',
    getKey: (filterUsage) => filterUsage.id,
    schema: z.object({ id: z.string(), type: z.string(), timestamp: z.number() }),
  }),
);
